
export const SIDENAV_DATA = ['Theme', 'Users', 'Pages', 'Settings', 'Publish', 'Timeline', 'Overview', 'Verified'];

export const SIDENAVA_META = [
  {
    label: 'Theme',
    icon: 'mdi-palette',
    link: ''
  }, {
    label: 'Pages',
    icon: 'mdi-window-restore',
    link: ''
  }, {
    label: 'Users',
    icon: 'mdi-account-group',
    link: ''
  }, {
    label: 'Settings',
    icon: 'mdi-cog',
    link: ''
  }, {
    label: 'Publish',
    icon: 'mdi-publish',
    link: ''
  }, {
    label: 'Timeline',
    icon: 'mdi-chart-timeline-variant-shimmer',
    link: ''
  }, {
    label: 'Overview',
    icon: 'mdi-file-clock',
    link: ''
  }, {
    label: 'Verified',
    icon: 'mdi-check-decagram',
    link: ''
  }

]

export const PAGETYPES = {
  splashScreen: 'SplashScreenPage',
  loginPage: 'LoginPage',
  landingPage: 'LandingPage',
  customPage: 'CustomPage',
  forgetPassword: 'ForgotPasswordPage',
  changePassword: 'ChangePasswordPage',
  previewPage: 'PreviewPage',
  logout: 'Logout'
}

export const FROMTYPES = {
  defaultForm: 'defaultForm',
  form: 'form',
  menuPanel: 'menuPanel',
  navBar: 'Navgation Bar'
}




/**When adding a new widget also update WIDGET_ACTIONS_VALIDATIONS with widget type and related actions and validations */
export const WIDGET_TYPES = {
  textbox: 'textbox',
  address: 'address',
  numeric_textbox: 'numeric_textbox',
  image: 'image',
  date: 'date',
  singleselectcheckbox: 'singleselectcheckbox',
  radio: 'radio',
  button: 'button',
  separator: 'separator',
  tabs: 'tabs',
  geotag: 'geotag',
  geofence : 'geofence',
  preview_group: 'preview_group',
  scanner: 'scanner',
  time_preview: 'time_preview',
  datalist: 'DataList',
  dropdown: 'dropdown',
  filePicker:'filepicker',
  plainText:'text',
  searchableDropdown:'searchableDropdown',
  imageUploader:'imageUploader',
  navButton: 'NavButton',
  navText: 'NavText',
  faceId:'faceId',
  fingerPrint:'fingerPrint',
  printer:'printer',
  barChart: 'barChart',
  lineChart: 'lineChart',
  pieChart: 'pieChart',
  donutChart:'donutChart',
  stackBarChart: 'stackBarChart',
  map: 'map',
  table: 'table',
  fixedBarChart : 'fixedBarChart'
};

export const ICON_TYPES = {
  menu: 1,
  arrow_back: 2,
  arrow_forward: 3,
  home: 4,
  notifications: 5,
  logout: 6,
  sync: 7,
  noIcon: 8,
};

export const WIDGET_CLICK_ACTIONS = {
  submit: "Submit",
  navigation : "Navigation",
  conditionalNavigation : "Conditional Navigation"
}

export const WIDGET_ACTION_NAMES =
["Submit","Navigation","Conditional Navigation"]

export const WIDGET_ACTIONS_VALIDATIONS = {
  textbox: { action: [], validation: ['Required', 'Minimum Length', 'Maximum Length'] },
  address: { action: [], validation: ['Required', 'Minimum Length', 'Maximum Length'] },
  numeric_textbox: { action: [], validation: [] },
  image: { action: [], validation: ['Required'] },
  date: { action: [], validation: ['Required'] },
  date_range: { action: [], validation: [] },
  singleselectcheckbox: {action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation],validation:['Required']},
  radio: {action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation],validation:['Required']},
  button: {action:[WIDGET_CLICK_ACTIONS.submit,WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation],validation:[]},
  separator: { action: [], validation: [] },
  tabs: { action: [], validation: [] },
  geotag: { action: [], validation: ['Required'] },
  preview_group: { action: [], validation: [] },
  scanner: { action: [], validation: ['Required'] },
  time_preview: { action: [], validation: [] },
  DataList: { action: [], validation: [] },
  dropdown: {action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation],validation:['Required']},
  filepicker:{action:[],validation:['Required']},
  text:{action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation],validation:[]},
  searchableDropdown:{action:[],validation:[]},
  imageUploader:{action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation],validation:[]},
  NavButton:{action:[WIDGET_CLICK_ACTIONS.navigation],validation:[]},
  NavText: { action: [], validation: [] },
  faceId: { action: [], validation: [] },
  fingerPrint: { action: [], validation: [] },
  printer:{action:[WIDGET_CLICK_ACTIONS.submit,WIDGET_CLICK_ACTIONS.navigation],validation:[]},
  barChart: { action: [], validation: [] },
  lineChart: { action: [], validation: [] },
  pieChart: { action: [], validation: [] },
  stackBarChart: { action: [], validation: [] },
  donutChart: { action: [], validation: [] },
  table:{action:[],validation:[]},
  fixedBarChart : {action:[],validation:[]} ,
};

export const pageTypeCnsts = {
  LOGIN: 'LoginPage',
  SPLASH_SCREEN: 'SplashScreenPage',
  PREVIEW: 'PreviewPage',
  COMPONENTS: 'components',
  SECTION: 'section',
  MENU_PANEL: 'menuPanel',
  DATA_LIST_VIEW: 'dataListView',
};


export const VALIDATIONS = {
  required: 'Required',
  maximum_length: 'Maximum Length',
  minimum_length: 'Minimum Length',
  start_date: 'Start Date',
  end_date: 'End Date',
};

export const MAT_UI_TYPES = {
  filled : 'fill',
  outlined:'outline'
}